import * as React from 'react'
import styled, { css } from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import { BaseLocationPickerProps } from './type'
import { LocationCard } from './LocationCard'

export type ListPickerProps = {
  className?: string
} & BaseLocationPickerProps

function ListPickerComponent({ className, locations, selected, onSelect }: ListPickerProps) {
  return (
    <ul className={className}>
      {locations.map((location, index) => {
        return (
          <Container key={`${location.coordinates.lon}:${location.coordinates.lat}`} active={selected === location.id}>
            <plume.RadioInput
              checked={selected === location.id}
              onChange={() => {
                onSelect?.(location)
              }}
            />
            <LocationCard location={location} index={index + 1} />
          </Container>
        )
      })}
    </ul>
  )
}

const Container = styled.li<{ active?: boolean }>`
  border: 1px solid ${plume.COLORS.BORDER_PRIMARY};
  display: flex;
  align-items: center;
  position: relative;

  ${plume.RadioInput} {
    padding: 16px;

    ${plume.styles.input.HiddenFocusableInput} {
      top: 0px;
      left: 0px;
    }
  }

  ${LocationCard} {
    padding-left: 0;
    flex: 1;
  }

  ${({ active }) => {
    if (active) {
      return css`
        border-color: ${plume.COLORS.PRIMARY_BLUE_500};

        &:not(:first-child) {
          margin-top: -1px;
        }
      `
    } else {
      return css`
        &:not(:first-child) {
          border-top: none;
        }
      `
    }
  }};
`

export const ListPicker = styled(ListPickerComponent)`
  list-style: none;
  padding: 0;
  max-height: 495px;
  overflow-y: auto;
`
